export default "__VITE_ASSET__qP95IQH6__"